import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import { getEventById } from '../../../../services/events';
import moment from 'moment-timezone';

interface EventsModalProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: string;
}
const EventsModal: React.FC<EventsModalProps> = ({ isOpen, onClose, eventId }) => {
  const [data, setData] = useState<any[]>([]);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);

  useEffect(() => {
    const getData = async () => {
      setIsLoadingData(true);
      try {
        const data = await getEventById(eventId);
        setData(data.payload?.logs);
      } catch (error) {
        console.log({ error });
      } finally {
        setIsLoadingData(false);
      }
    };

    if (isOpen) {
      getData();
    }
  }, [eventId, isOpen]);

  return (
    <Modal closeIcon open={isOpen} onClose={() => onClose()}>
      <Header icon="file alternate outline" content={`Logs`} />
      <Modal.Content scrolling>
        {isLoadingData ? (
          <div>
            <Icon name="spinner" loading />
            <p>Carregando...</p>
          </div>
        ) : (
          <div>
            <p>
              {data.map((log, index) => {
                return (
                  <p key={index}>
                    {moment(log.timestamp).format('DD/MM/YYYY HH:mm') } - {log.message}

                  </p>
                );
              })}
            </p>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={() => onClose()}>
          <Icon name="remove" /> Sair
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default EventsModal;
